import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import DifficultyFilter from './DifficultyFilter.jsx';
import TonalityFilter from './TonalityFilter.jsx';
import TitleFilter from './TitleFilter.jsx';
import AuthorFilter from './AuthorFilter.jsx';
import PerformerFilter from './PerformerFilter.jsx';
import StatusFilter from './StatusFilter.jsx';
import TypeFilter from './TypeFilter.jsx';


const FilterSet = (props) => {
  return <>
      { !props.isLoading && <>
      <TitleFilter/>
      <Row>
        { props.typeFilter && <Col xs={12} md={ props.colSize }><TypeFilter showEducation={ props.showEducation }/></Col> }
        { props.statusFilter && <Col xs={12} md={ props.colSize }><StatusFilter/></Col> }
        { (props.authorFilter && props.list) && <Col xs={12} md={ props.colSize }><AuthorFilter list={ props.list }/></Col> }
        { (props.performerFilter && props.list) && <Col xs={12} md={ props.colSize }><PerformerFilter list={ props.list }/></Col> }
        { props.difficultyFilter && <Col xs={12} md={ props.colSize }><DifficultyFilter/></Col> }
        { props.tonalityFilter && <Col xs={12} md={ props.colSize }><TonalityFilter/></Col> }
      </Row>
      </> }
  </>
};

FilterSet.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  typeFilter: PropTypes.bool,
  showEducation: PropTypes.bool,
  statusFilter: PropTypes.bool,
  authorFilter: PropTypes.bool,
  performerFilter: PropTypes.bool,
  difficultyFilter: PropTypes.bool,
  tonalityFilter: PropTypes.bool,
  list: PropTypes.array,
  colSize: PropTypes.number.isRequired
};

export default FilterSet;